// src/components/ReelCardForYou.jsx
import { useEffect, useState } from "react";
import API from "../config/api.js";

export default function ReelCardForYou({
  reel,
  day,
  month,
  onToggleQueue,
  scheduledInfo,
}) {
  const [iddraft, setIddraft] = useState(
    scheduledInfo?.iddraft || reel?.iddraft || ""
  );
  const [isQueued, setIsQueued] = useState(
    Boolean(scheduledInfo?.iddraft || reel?.iddraft)
  );
  const [scheduledText, setScheduledText] = useState(
    scheduledInfo?.scheduledText || ""
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setIddraft(scheduledInfo?.iddraft || reel?.iddraft || "");
    setIsQueued(Boolean(scheduledInfo?.iddraft || reel?.iddraft));
    setScheduledText(scheduledInfo?.scheduledText || "");
  }, [scheduledInfo, reel]);

  const getAbsoluteUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${API.baseUrl}/${path}`;
  };

  const getImageUrl = (path) => {
    if (!path) return "/assets/img/260x462.png";
    return getAbsoluteUrl(path);
  };

  const reelUrl = reel?.filewithmusic || reel?.file || "";
  const image = getImageUrl(reel?.image);
  const itemSource = reel?.iduser ? "user" : "platform";

  const handlePreview = (e) => {
    e.preventDefault();
    if (!reel?.idreel || !reelUrl) return;
    window._reel_load2?.(reel.idreel, reelUrl);
  };

  const handleDraft = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!reel?.iduser) {
      window._draft_prompt_clear?.();
    }

    window._draft_prompt_item_add?.(
      "reel",
      reel?.idreel,
      reelUrl,
      true,
      itemSource
    );
  };

  const handleQueueToggle = async (e) => {
    const checked = e.target.checked;

    if (!onToggleQueue || isSubmitting) return;

    setIsQueued(checked);
    setIsSubmitting(true);

    const result = await onToggleQueue({
      reel,
      checked,
      iddraft,
    });

    if (result?.success) {
      setIddraft(result.iddraft || "");
      setScheduledText(result.scheduledText || "");
      setIsQueued(checked);
    } else {
      setIsQueued(!checked);
    }

    setIsSubmitting(false);
  };

  if (!reel) return null;

  return (
    <div
      className={`card suggested reel reel-${reel.idreel} rounded-4 animate__animated animate__fadeIn animate__slow`}
      data-idreel={reel.idreel}
      data-url={reelUrl}
      data-iddraft={iddraft}
    >
      <a href="#preview" onClick={handlePreview}>
        <div className="position-relative">
          <img
            src="/assets/img/864x1080-transparent.png"
            onError={(e) => {
              e.currentTarget.src = "/assets/img/260x462.png";
            }}
            style={{
              background: `url('${image}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            loading="lazy"
            alt=""
            className="img-fluid w-100 rounded-3"
            width="260"
            height="462"
          />

          <div className="rounded position-absolute top-0 start-0 bottom-0 end-0 reel-preview"></div>

          <div className="position-absolute top-50 start-50 translate-middle text-center reel-play-pause z-2">
            <div className="d-inline-flex align-items-center justify-content-center bg-white bg-opacity-25 backdrop-blur rounded-circle">
              <img
                src="/assets/img/icon/play.png"
                className="position-relative"
                width="70"
                height="70"
                alt="play"
              />
            </div>
          </div>
        </div>
      </a>

      <div
        style={{ zIndex: 4 }}
        className="position-absolute top-0 start-0 end-0 m-1 card-actions"
      >
        <div className="mt-2 px-2 py-1 action-buttons d-flex align-items-center">
          <div className="form-check d-inline-block ms-2">
            <input
              className="form-check-input mt-0 fs-4"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-title="Add to queue"
              type="checkbox"
              role="switch"
              name="posted"
              checked={isQueued}
              disabled={isSubmitting}
              onChange={handleQueueToggle}
            />
          </div>

          <button
            style={{ marginBottom: "1px" }}
            type="button"
            className="btn bg-transparent text-white p-0 me-3 use-button"
            onClick={handleDraft}
          >
            <img
              src="/assets/img/circle-plus.png"
              width="26"
              height="26"
              alt=""
            />
          </button>
        </div>

        <div className="ms-1 px-2 text-white scheduled-date-time float-start">
          {scheduledText}
        </div>
      </div>

      <div
        style={{ zIndex: 3 }}
        className="position-absolute top-0 end-0 p-2 text-white scheduled-date-time"
      >
        {day && month ? (
          <div
            className="bg-white text-dark rounded text-center lh-1 p-2"
            style={{ width: "45px", height: "41px", fontSize: "12px" }}
          >
            <strong>{day}</strong>
            <br />
            {month}
          </div>
        ) : null}
      </div>

      <div
        style={{ zIndex: 4 }}
        className="position-absolute bottom-0 start-0 end-0 p-2 m-1"
      >
        <h6 className="text-white" style={{ fontWeight: 700, fontSize: "12px" }}>
          Reel{reel.categories ? ` • ${reel.categories}` : ""}
        </h6>

        <p className="card-text caption-content text-white">
          {reel.caption || reel.title || ""}
        </p>
      </div>
    </div>
  );
}